<form [formGroup]="form" class="eidos-reset-credentials-dialog">
  <h1 class="eidos-reset-credentials-dialog-title">Lost your credentials?</h1>

  <div class="eidos-reset-credentials-dialog-content" [ngSwitch]="status">
    <content *ngSwitchCase="EidosResetCredentialsStatus.Entered">
      <label class="credentials-reset-dialog-message">Insert your username or your user email to request a credentials reset</label>
      <div class="field">
        <label>Insert username or email</label>
        <input type="text" formControlName="username" required>
        <span class="field-error" *ngIf="form.controls.username.invalid && form.controls.username.touched">
          Insert username or email
        </span>
      </div>
    </content>
    <content *ngSwitchCase="EidosResetCredentialsStatus.Requested">
      <div class="reset-credentials-icon">
        <eidos-progress-spinner class="request-spinner" style="margin:0 auto;" [diameter]="60"></eidos-progress-spinner>
      </div>
      <p class="reset-credentials-message">Submitting request...</p>
    </content>
    <content *ngSwitchCase="EidosResetCredentialsStatus.Ok">
      <div class="reset-credentials-icon">
        <eidos-icon [iconConfiguration]="okIcon"></eidos-icon>
      </div>
      <div class="reset-credentials-message">Your request has been submitted. If user/email is existing and valid, you will receive instructions at your email address. Please check your inbox to confirm the request.</div>
    </content>
    <content *ngSwitchCase="EidosResetCredentialsStatus.Error">
      <div class="reset-credentials-icon">
        <eidos-icon [iconConfiguration]="clearIcon"></eidos-icon>
      </div>
      <p class="reset-credentials-message">Invalid or rejected request due to too many demands in a short period of time. Please retry in few minutes</p>
    </content>
  </div>

  <div class="eidos-reset-credentials-dialog-actions">
    <button class="eidos-button eidos-button-normal eidos-button-cancel" type="button" (click)="onCancelClick()">Cancel</button>
    <button *ngIf="status === EidosResetCredentialsStatus.Ok" class="eidos-button eidos-button-normal eidos-button-success" type="submit" (click)="onCancelClick()">Close</button>
    <button *ngIf="status === EidosResetCredentialsStatus.Entered" class="eidos-button eidos-button-normal eidos-button-success" type="submit" (click)="onSubmit()" [disabled]="form.invalid">Submit</button>
    <button *ngIf="status === EidosResetCredentialsStatus.Error" class="eidos-button eidos-button-normal eidos-button-success" type="submit" (click)="onRetry()">Retry</button>
  </div>
</form>
